<div aria-live="polite" aria-atomic="true">
    <div *ngIf="errorList.length > 0"
        [ngStyle]="{'position': 'absolute',
            'bottom': '0px',
            'right': '0px',
            'min-width': minWidth ? minWidth + 'px' : '300px',
            'max-width': maxWidth ? maxWidth + 'px' : '',
            'border': '1px solid #a20000',
            'background-color': 'white'
        }">
        <div style="background-color:#a20000;color:white;line-height:normal;padding:5px;">
            <span translate>Errors were found. Please see details below.</span>
        </div>
        <div style="overflow: auto; padding:10px; width: 100%;">
            <table>
                <tr *ngFor="let error of errorList;">
                    <td (click)="errorLinkClick(error)" style="padding-right:10px;">
                        <ng-container *ngIf="error.fieldName && error.fieldName.length > 0">
                                <a style="cursor: pointer;" *ngIf="error.fieldRef || error.clickCallback" translate>{{error.fieldName}}</a>
                                <span *ngIf="!error.fieldRef && !error.clickCallback" translate>{{error.fieldName}}</span>
                                <span>: </span>
                        </ng-container>
                        <span [innerHTML]="error.errorMsg | safeHtml" translate></span>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>
